module.exports = __webpack_public_path__ + "img/systems.187c3de5.svg";